import React from "react";

const notificationContext = React.createContext({ notifications: null, notify: (_) => _ });

export { notificationContext };
